import Reveal from "@/components/Reveal";

export default function SectionHeading({ overline, title, subtitle, align = "center", light = false, testId }) {
  const alignClass = align === "left" ? "text-left items-start" : "text-center items-center";
  const overlineColor = light ? "text-gold" : "text-gold";
  const titleColor = light ? "text-cream" : "text-ink";
  const subColor = light ? "text-cream/80" : "text-ink-muted";
  return (
    <Reveal className={`flex flex-col ${alignClass}`} data-testid={testId}>
      {overline && (
        <p className={`text-xs tracking-[0.35em] uppercase mb-5 ${overlineColor}`}>{overline}</p>
      )}
      <h2 className={`font-heading font-light text-4xl sm:text-5xl leading-tight ${titleColor}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-5 max-w-2xl text-base sm:text-lg font-light ${subColor}`}>{subtitle}</p>
      )}
    </Reveal>
  );
}
